import { render, staticRenderFns } from "./SchoolNotifiation.vue?vue&type=template&id=b9faab7e&scoped=true"
import script from "./SchoolNotifiation.vue?vue&type=script&lang=js"
export * from "./SchoolNotifiation.vue?vue&type=script&lang=js"
import style0 from "./SchoolNotifiation.vue?vue&type=style&index=0&id=b9faab7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9faab7e",
  null
  
)

export default component.exports